import { action, actionOn, thunk } from "easy-peasy";
import axios from '../services/axios';

const apkInitialState = {
    allApk: [],
    isFetchingAllApk: false,
    isUpdateNecessary: true,
    initialFetchDone: false,
    apkById: null,
    isFetchingOneApk: false,
}

const apk = {
    ...apkInitialState,

    onGlobalResetCalled: actionOn(
        (actions, storeActions) => [
            storeActions.resetStore.performReset,
        ],
        (state, target) => {
            const [performReset] = target.resolvedTargets;

            if (target.type === performReset) {
                ({
                    allApk: state.allApk,
                    isFetchingAllApk: state.isFetchingAllApk,
                    isUpdateNecessary: state.isUpdateNecessary,
                    initialFetchDone: state.initialFetchDone,
                    apkById: state.apkById,
                    isFetchingOneApk: state.isFetchingOneApk
                } = apkInitialState);
            }
        }
    ),

    setAllApk: action((state, payload) => {
        state.allApk = payload;
    }),

    setIsFetchingAllApk: action((state, payload) => {
        state.isFetchingAllApk = payload;
    }),

    setApkById: action((state, payload) => {
        state.apkById = payload;
    }),

    setIsFetchingOneApk: action((state, payload) => {
        state.isFetchingOneApk = payload;
    }),

    setIsUpdateNecessary: action((state, payload) => {
        state.isUpdateNecessary = payload;
    }),

    setInitialFetchDone: action((state, payload) => {
        state.initialFetchDone = payload;
    }),


    fetchApkById: thunk((actions, payload, helpers) => {
        const { isFetchingOneApk } = helpers.getState();
        const apiData = helpers.getStoreState().actionSlugs.apiData;

        const getOneUrl = apiData.ACTIONS?.apks?.readOne?.url?.replace('uniqueId', payload);

        if (!isFetchingOneApk) {
            actions.setIsFetchingOneApk(true);
            actions.setApkById(null);

            return axios.get(getOneUrl)
                .then((data) => {
                    actions.setIsFetchingOneApk(apkInitialState.isFetchingOneApk);
                    actions.setApkById(data);
                })
                .catch(error => Promise.reject(error));
        } else {
            return Promise.resolve();
        }
    }),


    createApk: thunk((actions, payload, helpers) => {

        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const { packages } = helpers.getStoreActions();
        const createApkUrl = ACTIONS?.apks?.create?.url;

        return axios.post(createApkUrl, payload?.data)
            .then((apk) => {
               packages.updatePackageApks(apk);
               return apk;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    updateApkProps: thunk((actions, payload, helpers) => {
        const allApk = helpers.getState().allApk;

        const newAllApk = allApk
            .map(apk => {
                const newApk = payload?.find(newApk => apk.uniqueId === newApk.uniqueId);
                return { ...apk, ...newApk }
            });

        actions.setAllApk(newAllApk);
    }),

    updateApk: thunk((actions, payload, helpers) => {
        const { data, uniqueId } = payload;
        
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const { packages } = helpers.getStoreActions();
        const updateApkUrl = ACTIONS?.apks?.update?.url?.replace('uniqueId', uniqueId);

        return axios.post(updateApkUrl, data)
            .then((apk) => {
                actions.updateApkProps(apk);
                packages.updatePackageApks(apk);
                return apk;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    })
}

export default apk;